import React from 'react';
import { CheckCircle2Icon, ShieldIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL, CTAButton, INSTAGRAM_LINK, PAYMENT_NOTE, PRICE, PRICE_SHORT, Section, SUPPORT_EMAIL } from './Shared';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-31" data-mp="vks3lw1fgllw">
      <div className="relative overflow-hidden rounded-3xl border border-brand-gold/45 bg-white p-6 text-center shadow-lg md:p-12" data-id="element-32" data-mp="qn9qdtgdnk83">
        <div aria-hidden="true" className="absolute left-0 top-0 h-28 w-28 rounded-br-full bg-brand-purpleMist" data-id="element-33" data-mp="mly868zu219x" />
        <div aria-hidden="true" className="absolute bottom-0 right-0 h-28 w-28 rounded-tl-full bg-brand-goldLight/60" data-id="element-34" data-mp="hlsg4rpnicrb" />
        <div className="relative" data-id="element-35" data-mp="cnqv418o03d7">
          <h2 className="mb-8 font-display text-3xl font-bold leading-tight text-brand-purpleDark md:text-4xl" data-id="element-36" data-mp="7onowdgy7r3n">
            Hay dos versiones de ti en este momento.
          </h2>
          <div className="mx-auto mb-10 max-w-2xl space-y-5 text-base leading-relaxed text-brand-text md:text-lg" data-id="element-37" data-mp="26z5ocs0vwkxp">
            <p data-id="element-38" data-mp="352slcgqq2b0v">
              Una que cierra esta página y sigue reuniendo información suelta, intentando recordar qué piedra elegir,
              cómo preparar el espacio o qué consultar antes de cada sesión.
            </p>
            <p className="font-semibold text-brand-purple" data-id="element-39" data-mp="2v54mpfpzwjdf">
              Y otra que decide tener hoy una biblioteca completa para estudiar, organizar y acompañar su práctica con
              más claridad.
            </p>
            <p className="font-serif text-lg italic text-brand-goldDark md:text-xl" data-id="element-40" data-mp="3ntips9vxy5vu">
              La pregunta no es si puedes acceder al pack.
              <br data-id="element-41" data-mp="3e37bpuijmgb8" />
              La pregunta es cuánto tiempo más quieres seguir buscando todo por separado.
            </p>
          </div>

          <div className="mx-auto mb-10 max-w-md rounded-2xl border-2 border-brand-gold/60 bg-white p-6 shadow-[0_10px_30px_rgba(42,18,89,.14)]" data-id="element-42" data-mp="3j0zbtbtcd8qi">
            <span className="relative -top-9 rounded-full bg-brand-purple px-3 py-1 text-xs font-bold text-brand-goldLight" data-id="element-43" data-mp="aknstilr8mt3">
              ⭐ MÁS ELEGIDO
            </span>
            <h3 className="-mt-4 font-serif text-xl font-bold text-brand-purpleDark" data-id="element-44" data-mp="p8ebydb38ust">
              🏆 MEGA PACK MAESTRO DE GEMOTERAPIA™
            </h3>
            <p className="my-2 text-4xl font-bold text-brand-purple" data-id="element-45" data-mp="g7zlz0n6iriz">{PRICE}</p>
            <p className="mb-5 text-sm leading-relaxed text-brand-muted" data-id="element-46" data-mp="b9emj3fr4bvl">
              4 Tomos + 5 Bonus Estratégicos. Todo el sistema de fundamentos, protocolos, cristales, chakras, protección
              personal, seguimiento y armonización de espacios en un solo lugar.
            </p>
            <CTAButton href={CHECKOUT_URL} fullWidth className="text-sm md:text-base" data-id="element-47" data-mp="3spw65hxxu3ar">
              🏆 → QUIERO MI MEGA PACK POR {PRICE_SHORT}
            </CTAButton>
            <p className="mt-3 text-xs font-medium text-brand-textLight md:text-sm" data-id="element-48" data-mp="3opvq5sv6xk1l">{PAYMENT_NOTE}</p>
          </div>

          <div className="mb-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-brand-muted md:text-sm" data-id="element-49" data-mp="3jraum6qvvojh">
            <span className="flex items-center" data-id="element-50" data-mp="1u82rbw0tiudn">
              <CheckCircle2Icon className="mr-1.5 h-4 w-4" data-id="element-51" data-mp="1u7awinf1p0of" />
              Pago seguro
            </span>
            <span className="flex items-center" data-id="element-52" data-mp="1z5m4stpoz34j">
              <ZapIcon className="mr-1.5 h-4 w-4" data-id="element-53" data-mp="246jml56shv5i" />
              Acceso en minutos
            </span>
            <span className="flex items-center" data-id="element-54" data-mp="287lmzpcg0d92">
              <ShieldIcon className="mr-1.5 h-4 w-4" data-id="element-55" data-mp="287by6534wc4y" />
              Garantía de 7 días
            </span>
          </div>

          <div className="rounded-2xl border border-brand-purple/15 bg-brand-surfaceLight p-5 text-left text-sm leading-relaxed text-brand-text md:p-6 md:text-center" data-id="element-56" data-mp="1bfrtwhoxnomx">
            <p data-id="element-57" data-mp="1kgq096mug88o">
              <strong className="text-brand-purpleDark" data-id="element-58" data-mp="1kgzoops8q7c9">P.D.:</strong> Si tienes dudas, escríbenos a{' '}
              <a className="font-semibold text-brand-purple hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-59" data-mp="1pb41hpo6t9l9">
                {SUPPORT_EMAIL}
              </a>{' '}
              o encuéntranos en Instagram como{' '}
              <a className="font-semibold text-brand-purple hover:underline" href={INSTAGRAM_LINK} data-id="element-60" data-mp="do3apbxl58jq">
                @lumen.akasha
              </a>
              .
            </p>
            <p className="mt-3 italic text-brand-goldDark" data-id="element-61" data-mp="8mw3bdzcubdl">
              El precio de lanzamiento finaliza pronto. Este es el momento de reunir tu biblioteca de Gemoterapia en un
              solo lugar.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}